//Images
import fullcatalog from '@/assets/images/products/fullcatalog-screenshot.png'
import tracking from '@/assets/images/products/map-vertical.png'
import shippingRules from '@/assets/images/products/shippingrules-3.jpg'
import defectiveflow from '@/assets/images/products/defectiveflow-photo.jpg'
import sizeggestionsPreview from '@/assets/images/products/size-suggestions.jpg'
import sizeggestions from '@/assets/images/products/size-suggestions-2.png'
import rdvsurplusPreview from '@/assets/images/products/rdv-surplus.jpg'
import rdvsurplus from '@/assets/images/products/rdv-surplus-2.png'
import kyi from '@/assets/images/products/kyi.jpg'
import E1toN from '@/assets/images/products/exchanges_1_to_n.png'
import ProductSuggestions from '@/assets/images/products/product_suggestions.png'
import FiltersInDashboard from '@/assets/images/products/filters-dashboard.jpg'
import Tiktok from '@/assets/images/products/tiktok_banner_new.png'
import TiktokPreview from '@/assets/images/products/tiktok-preview.png'

type FeaturedProduct = {
  name: string
  description: string
  longDescription: string
  features?: string[]
  previewImage: string
  mainImage: string
  mode: 'info' | 'request'
  onlyShopify: boolean
  layout: 'horizontal' | 'vertical'
  isNew?: boolean
  redirectUrl?: string
  ctaText?: string
}

const featuredProducts: FeaturedProduct[] = [
  {
    name: 'tiktok.name',
    description: 'tiktok.description',
    longDescription: 'tiktok.longDescription',
    features: ['tiktok.feature1', 'tiktok.feature2', 'tiktok.feature3'],
    previewImage: TiktokPreview,
    mainImage: Tiktok,
    mode: 'request',
    onlyShopify: false,
    layout: 'horizontal',
    isNew: true,
    redirectUrl: '/account/integrations/details/TikTok%20Shop'
  },
  {
    name: 'full_catalog_exchanges.name',
    description: 'full_catalog_exchanges.description',
    longDescription: 'full_catalog_exchanges.longDescription',
    features: [
      'full_catalog_exchanges.feature1',
      'full_catalog_exchanges.feature2',
      'full_catalog_exchanges.feature3',
      'full_catalog_exchanges.feature4'
    ],
    previewImage: fullcatalog,
    mainImage: fullcatalog,
    mode: 'request',
    onlyShopify: true,
    layout: 'vertical',
    isNew: false
  },
  {
    name: 'exchanges_1_to_n.name',
    description: 'exchanges_1_to_n.description',
    longDescription: 'exchanges_1_to_n.longDescription',
    features: ['exchanges_1_to_n.feature1', 'exchanges_1_to_n.feature2'],
    previewImage: E1toN,
    mainImage: E1toN,
    mode: 'request',
    onlyShopify: true,
    layout: 'vertical',
    isNew: false
  },
  {
    name: 'filters_dashboard.name',
    description: 'filters_dashboard.description',
    longDescription: 'filters_dashboard.longDescription',
    features: ['filters_dashboard.feature1', 'filters_dashboard.feature2'],
    previewImage: FiltersInDashboard,
    mainImage: FiltersInDashboard,
    mode: 'info',
    onlyShopify: true,
    layout: 'horizontal',
    isNew: false,
    redirectUrl: '/analytics/compensation'
  },
  {
    name: 'product_recommender.name',
    description: 'product_recommender.description',
    longDescription: 'product_recommender.longDescription',
    features: ['product_recommender.feature1', 'product_recommender.feature2'],
    previewImage: ProductSuggestions,
    mainImage: ProductSuggestions,
    mode: 'request',
    onlyShopify: true,
    layout: 'vertical',
    isNew: true
  },

  {
    name: 'rdv_surplus.name',
    description: 'rdv_surplus.description',
    longDescription: 'rdv_surplus.longDescription',
    features: [
      'rdv_surplus.feature1',
      'rdv_surplus.feature2',
      'rdv_surplus.feature3'
    ],
    previewImage: rdvsurplusPreview,
    mainImage: rdvsurplus,
    mode: 'request',
    onlyShopify: false,
    layout: 'vertical',
    isNew: false
  },
  {
    name: 'size_suggestion.name',
    description: 'size_suggestion.description',
    longDescription: 'size_suggestion.longDescription',
    features: [
      'size_suggestion.feature1',
      'size_suggestion.feature2',
      'size_suggestion.feature3'
    ],
    previewImage: sizeggestionsPreview,
    mainImage: sizeggestions,
    mode: 'request',
    onlyShopify: true,
    layout: 'vertical',
    isNew: true
  },
  {
    name: 'keep_your_item.name',
    description: 'keep_your_item.description',
    longDescription: 'keep_your_item.longDescription',
    features: ['keep_your_item.feature1', 'keep_your_item.feature2'],
    previewImage: kyi,
    mainImage: kyi,
    mode: 'request',
    onlyShopify: false,
    layout: 'vertical',
    isNew: true
  },
  {
    name: 'tracking_interface.name',
    description: 'tracking_interface.description',
    longDescription: 'tracking_interface.longDescription',
    features: [
      'tracking_interface.feature1',
      'tracking_interface.feature2',
      'tracking_interface.feature3',
      'tracking_interface.feature4'
    ],
    previewImage: tracking,
    mainImage: tracking,
    onlyShopify: false,
    mode: 'info',
    layout: 'vertical',
    redirectUrl: '',
    ctaText: 'tracking_interface.cta_text'
  },
  {
    name: 'logistic_costs.name',
    description: 'logistic_costs.description',
    longDescription: 'logistic_costs.longDescription',
    features: [
      'logistic_costs.feature1',
      'logistic_costs.feature2',
      'logistic_costs.feature3'
    ],
    previewImage: shippingRules,
    mainImage: shippingRules,
    onlyShopify: false,
    mode: 'info',
    layout: 'vertical',
    redirectUrl: '/configuration/shipping'
  },
  {
    name: 'defective_flow.name',
    description: 'defective_flow.description',
    longDescription: 'defective_flow.longDescription',
    features: ['defective_flow.feature1', 'defective_flow.feature2'],
    previewImage: defectiveflow,
    mainImage: defectiveflow,
    onlyShopify: false,
    mode: 'request',
    layout: 'vertical'
  }
]
export default featuredProducts
